// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ITrainingPlace {
  name: string;
  address: string;
  mapLink: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

export const useTrainingPlaces = (): ITrainingPlace[] => {
  return [
    {
      name: 'Kuchyňa',
      address: 'Základná škola, Kuchyňa 551, 90052 Kuchyňa',
      mapLink:
        'https://www.google.com/maps/place/Z%C3%A1kladn%C3%A1+%C5%A1kola+s+materskou+%C5%A1kolou/@48.403741,17.158379,17z/data=!3m1!4b1!4m6!3m5!1s0x476cbfe3dda3738f:0x83447a31b19cf5cc!8m2!3d48.403741!4d17.158379!16s%2Fg%2F11h00dqft?entry=ttu',
      coordinates: {
        lat: 48.403934,
        lng: 17.158308
      }
    },
    {
      name: 'Aircraft Sport House',
      address: 'Ivánska cesta 30D, 821 04 Bratislava',
      mapLink:
        'https://www.google.com/maps/place/Aircraft+Sport+House/@48.174888,17.190607,15z/data=!4m5!3m4!1s0x0:0x1616a13f19000b1f!8m2!3d48.174888!4d17.190607',
      coordinates: {
        lat: 48.174888,
        lng: 17.190607
      }
    },
    {
      name: 'Monkeyfit',
      address: 'Hauptplatz 37, 2421 Kittsee',
      mapLink: `https://www.google.com/maps/place/Monkeyfit/@48.0895535,17.0674034,15z/data=!4m5!3m4!1s0x0:0x8990c56948ba7c2!8m2!3d48.0895535!4d17.0674034`,
      coordinates: {
        lat: 48.0895535,
        lng: 17.0674034
      }
    }
  ];
};
